module.exports = __webpack_public_path__ + "static/media/image-3.a3ec1536.jpg";